import BaseViewModel from "../../Core/BaseViewModel";
import WishlistModel from "../../Models/WishlistModel";

export default class WishlistViewModel extends BaseViewModel{
	loading: boolean = false;
	wishlists: WishlistModel[] = [];
	wishlistDeleteModal: boolean = false;
	actionItem: any;
	deleteProcessing: boolean = false;
}